import { create } from "zustand";
import { DialogInfo, PageUnit } from "./data";

const defaultDialog : DialogInfo = {
    id: "",
    title: "Title",
    content: "",
    visible: true,
    confirmContent: "Confirm",
    confirmActive: true,
    onConfirm: () => {}
}

type ToastData = {
    Id      : number
    Title   : string
    Msg     : string
    Date    : Date
    Visible : boolean
}

type UXStoreProps = {
    pages       :Array<PageUnit>
    toasts      :ToastData[]
    currentPage :PageUnit | null
    pushPage: (label:string,element:any) => void
    replacePage: (label:string, element:any) => void
    popPage: () => void
    popUntil: (predicate:(page:PageUnit) => boolean) => void
    popAt: (index:number) => void

    // dialogs
    dialogs         : Map<string,DialogInfo>
    refreshDialog       : (dialog:DialogInfo,autohide?:boolean) => void
    removeDialog : (id:string) => void
    hideDialog : (id:string) => void

    // toasts
    addToast : (title:string,msg:string,date?:Date) => number
    dismissToast : (id:number) => void
    purgeToast : (id:number) => void
}

var toastRunning = 0

const useUXStore = create<UXStoreProps>( (set,getState) => ({
    pages:[],
    toasts:[],
    currentPage: null,
    pushPage(label, element) {
        const page = {Label:label,Element:element};
        let pages = getState().pages
        pages = [...pages, page]
        set( state => ({pages:pages, currentPage:page}))
    },
    replacePage(label, element) {
        const page = {Label:label,Element:element};
        set( state => ({pages:[page], currentPage:page}))
    },
    popPage() {
        let pages = getState().pages
        // skip popping
        if (pages.length < 2) return
        pages = [...pages]
        pages.pop()
        set( state => ({pages:pages, currentPage:pages[pages.length-1]}))
    },
    popUntil(predicate) {
        const originalPages = getState().pages
        let pages = [...originalPages]
        for (let index = 0; index < pages.length; index++) {
            const page = pages[index];
            if (!predicate(page!)) return

            pages.pop()
        }
        if (originalPages.length !== pages.length) {
            set( state => ({
                pages:pages, 
                currentPage: pages[pages.length-1]
            }))
        }
    },
    popAt(index) {
        const target= getState().pages[index]
        getState().popUntil( page => page.Label !== target.Element )
    },

    // dialogs
    dialogs : new Map<string, DialogInfo>(),
    refreshDialog: (dialog: DialogInfo, autohide=false) => {
        const dialogs = getState().dialogs
        const oldD = dialogs.get(dialog.id)
        const newD = oldD ? {...oldD, ...dialog} : {...defaultDialog, ...dialog} 
        if (autohide) {
            newD.onClose = () => getState().hideDialog(newD.id)
            newD.onConfirm = () => {
                if (dialog.onConfirm)
                    dialog!.onConfirm!()
                getState().hideDialog(newD.id)
                //console.log("hide")
            }
        }
        dialogs.set(dialog.id, newD)

        set( state => ({dialogs:dialogs}))
    },
    hideDialog(id) {
        getState().refreshDialog({id,visible:false})
    },
    removeDialog: (id:string) => {
        const newD = getState().dialogs
        newD.delete(id)
        set( state => ({dialogs: newD}))
    }, 
    addToast(title, msg, date) {
        const toasts = [...getState().toasts]
        toastRunning ++
        if (date === null) date = new Date(Date.now())
        toasts.push({Id:toastRunning, Title:title,Msg:msg, Date:date!, Visible:true})
        set( state => ({toasts:toasts}))
        return toastRunning
    },
    dismissToast(id) {
        const toasts = [...getState().toasts]
        for (let index = 0; index < toasts.length; index++) {
            const element = toasts[index];
            if (element.Id === id) {
                toasts[index] = {...element, Visible:false}
                set( state => ({toasts:toasts}))
                setTimeout(() => getState().purgeToast(id), 300)
                break
            }
        }
    },
    purgeToast(id) {
        const toasts = [...getState().toasts]
        for (let index = 0; index < toasts.length; index++) {
            const element = toasts[index];
            if (element.Id === id) {
                toasts.splice(index, 1)
                set( state => ({toasts:toasts}))
                break
            }
        }
    },
}))

export default useUXStore
